import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PriceTableComponent } from './price-table.component';
import { CarouselSwiperModule } from '../carousel-swiper/carousel-swiper.module';



@NgModule({
  declarations: [
    PriceTableComponent
  ],
  imports: [
    CommonModule,
    CarouselSwiperModule
  ],
  exports: [
    PriceTableComponent
  ]
})
export class PriceTableModule { }
